import { Model } from '../../_kernel/architecture'
import { z } from 'zod'

export type PaymentPolicies = (typeof AVAILABLE_PAYMENT_POLICY)[number]

const AVAILABLE_PAYMENT_POLICY = ['NRF', 'NOR', 'SFL', 'NORE'] as const

export const PaymentPolicyValidation = z.object({
  value: z.enum(AVAILABLE_PAYMENT_POLICY, { message: '[PaymentPolicy] value is required' }),
})

export class PaymentPolicy extends Model {
  static create({ value }: z.infer<typeof PaymentPolicyValidation>) {
    PaymentPolicyValidation.parse({ value })
    return new PaymentPolicy(value)
  }

  static fromJSON(json: ReturnType<PaymentPolicy['toJSON']>) {
    return PaymentPolicy.create({
      value: json.value,
    })
  }

  static fromLiterals({ value }: { value: PaymentPolicies }) {
    return PaymentPolicy.create({
      value,
    })
  }

  constructor(private readonly _value: PaymentPolicies) {
    super()
  }

  get value() {
    return this._value
  }

  toJSON() {
    return {
      value: this._value,
    }
  }

  isNRF(): this is PaymentPolicy & { _value: 'NRF' } {
    return this._value === 'NRF'
  }

  isSFL(): this is PaymentPolicy & { _value: 'SFL' } {
    return this._value === 'SFL'
  }

  isNOR(): this is PaymentPolicy & { _value: 'NOR' } {
    return this._value === 'NOR'
  }

  isNORE(): this is PaymentPolicy & { _value: 'NORE' } {
    return this._value === 'NORE'
  }
}
